import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { LoaderService } from '../service/loader.service';
import { AuthService } from '../service/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private ignoredRoutes: string[] = ['/auth/login', '/auth/register'];
  private noLoaderRoutes: string[] = ['/user/customers', '/user/']; // Routes that don't need global loader
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private authService: AuthService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldIgnore = this.ignoredRoutes.some((route) => req.url.includes(route));
    const shouldNotShowLoader = this.noLoaderRoutes.some((route) => req.url.includes(route));

    // If it's an ignored route, proceed without modifying the request
    if (shouldIgnore) {
      return next.handle(req);
    }

    // Show global loader only for routes that need it
    if (!shouldNotShowLoader) {
      this.loaderService.showLoader();
    }

    // Get access token from LocalStorageService
    const token = this.authService.getAuthToken()?.access_token;

    // If no token is found, navigate to the login page
    if (!token) {
      this.router.navigate(['/auth/login']); // Navigate to the login page
      return new Observable<HttpEvent<any>>(); // Prevent further request handling
    }

    // If the token exists, clone the request and add the Authorization header
    const clonedRequest = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });

    return next.handle(clonedRequest).pipe(
      catchError((err: HttpErrorResponse) => {
        if (!shouldNotShowLoader) {
          this.loaderService.hideLoader();
        }
        return throwError(err);
      }),
      finalize(() => {
        if (!shouldNotShowLoader) {
          this.loaderService.hideLoader();
        }
      }),
    );
  }
}
